// @ts-nocheck
"use client";

import { useEffect } from "react";

import BentoModules from "./sections/BentoModules";
import CTASection from "./sections/CTASection";
import Differentiators from "./sections/Differentiators";
import Engines from "./sections/Engines";
import FAQ from "./sections/FAQ";
import Footer from "./sections/Footer";
import Hero from "./sections/Hero";
import HorizontalScroll from "./sections/HorizontalScroll";
import HowItWorks from "./sections/HowItWorks";
import Interlude from "./sections/Interlude";
import Navbar from "./sections/Navbar";
import Overlays from "./sections/Overlays";
import PersonaSwitcher from "./sections/PersonaSwitcher";
import PlatformInMotion from "./sections/PlatformInMotion";
import PressMarquee from "./sections/PressMarquee";
import Stats from "./sections/Stats";
import StickyStory from "./sections/StickyStory";
import Testimonials from "./sections/Testimonials";

export default function Sections() {
  // Section initialisers (initCanvas, initHScroll, …) are invoked inside
  // ClientScripts.tsx's own useEffect — no setTimeout polling here.
  // This effect only wires DOM click handlers that delegate to window globals
  // attached by ClientScripts; the globals are guaranteed to exist by the time
  // a user actually clicks anything.
  useEffect(() => {
    const w = window as any;

    document.querySelectorAll('.mpd').forEach((el, i) => {
      el.addEventListener('click', () => w.goScene && w.goScene(i));
    });
    document.getElementById('prevBtn')?.addEventListener('click', () => w.prevScene && w.prevScene());
    document.getElementById('pauseBtn')?.addEventListener('click', () => w.togglePause && w.togglePause());
    document.getElementById('nextBtn')?.addEventListener('click', () => w.nextScene && w.nextScene());

    document.querySelectorAll('.ptab').forEach(btn => {
      const pid = (btn as HTMLElement).dataset.persona || '';
      btn.addEventListener('click', () => w.setP && w.setP(btn, pid));
    });

    document.querySelectorAll('.tgl').forEach(btn => {
      const group = (btn as HTMLElement).dataset.group || 'all';
      btn.addEventListener('click', () => w.filterP2 && w.filterP2(btn, group));
    });

  }, []);

  return (
    <>
      <Overlays />
      <Navbar />
      {/* Homepage does not use PageShell, so it declares its own <main> —
         it is the target of Navbar's "Skip to content" link. */}
      <main id="main">
        <Hero />
        <PressMarquee />
        <Differentiators />
        <Engines />
        <BentoModules />
        <StickyStory />
        <Interlude />
        <PlatformInMotion />
        <Stats />
        <HowItWorks />
        <HorizontalScroll />
        <Testimonials />
        <PersonaSwitcher />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
